import { watch } from 'vue'

import { useAudienceUiStore } from '../stores/audienceUiStore'
import { useFunnelStore } from '../stores/funnelStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** Clear the workspace-scoped funnel data on a workspace switch and on session teardown.
 *
 *  `audienceUiStore` is NOT in the workspace watch: its metric picks and funnel view types are
 *  already partitioned by workspace id (`${workspaceId}:${panel}`), so switching away and back
 *  must restore the analyst's choice. It is still account-bound — the keys name the previous
 *  tenant's workspaces — so a session reset drops it. */
export function registerAudienceLifecycle(): () => void {
  const funnels = useFunnelStore()
  const ui = useAudienceUiStore()
  const { workspaceId } = useWorkspace()
  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) funnels.resetState()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(() => {
    funnels.resetState()
    ui.resetState()
  })
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
